module.exports = __webpack_public_path__ + "img/6354613687233450007845073.53315af2.jpg";